export const STYLES = {
  MAIN_BTN:
    'absolute right-[10px] bottom-[100px] z-40 w-[46px] h-[46px] rounded-full bg-action03 flex items-center justify-center cursor-pointer shadow-helpMenuButton hover:bg-action04',
  BUTTONS_CONTAINER:
    'absolute z-40 translate-y-[-87px] -translate-x-[48px] flex flex-col w-[142px] h-[111px] gap-[11px]',
  X_ICON: 'absolute w-[17px] h-[17px]',
  CHAT_QUESTION_ICON: 'absolute w-[28px] h-[26.6px] mt-[2px]',
  QUESTION_ICON: 'font-metricMedium text-bw00 leading-[17px] text-center text-sm mb-[5px]',
  CHAT_BTN:
    'w-full h-full flex items-center bg-bw02 rounded-[100px] text-bw06 text-xs font-metric shadow-chatBotButton',
  CHAT_ICON: 'w-[17px] h-[16.25px] mr-[12px] ml-[29px]',
  HELP_CENTER_BTN:
    'w-full h-full flex items-center bg-bw02 rounded-[100px] text-bw06 text-xs font-metric shadow-chatBotButton',
  HELP_CENTER_ICON: 'w-[17px] h-[16.25px] mr-[12px] ml-[29px]',
  APPEARANCE_ANIMATION: 'animate-helpMenuAppearance',
  DISAPPEARANCE_ANIMATION: 'animate-helpMenuDisappearance',
};

export const TEXTS = {
  CHAT: 'CHAT_BOT.CHAT_BTN',
  HELP_CENTER: 'CHAT_BOT.HELP_CENTER_BTN',
} as const;
